import { useEffect, useState } from "react";
import api from "../lib/api";
import { ShieldSlash } from "@phosphor-icons/react";

const EXEMPT = new Set(["GO2", "GOP2", "CLO", "CLOP"]);

// Dashboard note for entities registered ONLY with CIP-exempt functions (mirrors backend _cip_scope_rule).
export const CipExemptBanner = () => {
  const [funcs, setFuncs] = useState(null);
  useEffect(() => { api.get("/entity-profile").then((r) => setFuncs(r.data?.registered_functions || [])).catch(() => {}); }, []);
  if (!funcs || !funcs.length || !funcs.every((f) => EXEMPT.has(f))) return null;
  return (
    <div className="flex items-start gap-3 border border-emerald-300 bg-emerald-50 px-4 py-3 mb-6 text-sm" data-testid="cip-exempt-banner">
      <ShieldSlash size={20} weight="duotone" className="text-emerald-700 shrink-0 mt-0.5" />
      <div>
        <div className="font-semibold text-emerald-900">CIP does not apply to your registration</div>
        <div className="text-emerald-800 text-xs mt-0.5">
          Your entity is registered only as {funcs.join(", ")}. Category-2 generators (GO2/GOP2) and Computational Load
          entities (CLO/CLOP) have no NERC CIP obligations, so CIP-002 through CIP-015 are excluded from your requirements,
          gaps and manuals. If your registration changes, update your Entity Profile.
        </div>
      </div>
    </div>
  );
};
